import Vue from 'vue'
import VueI18n from 'vue-i18n'
import messages from './index.js'
Vue.use(VueI18n)
const i18n = new VueI18n({
    locale: localStorage.getItem("currentLanage") || "zh",
    messages,
    // silentTranslationWarn: true 
})

export default i18n


// WEBPACK FOOTER //
// ./src/common/i18n/i18n.js